import * as React from 'react';
import * as Glob from '../Globale';
import * as Compat from '../Compat';
import { Metodi } from '../ChiamaWeb';

interface IChiamaAPIProps {
    Nome?: string;
    Aggiornare: number //Per richiedere il caricamento dell'API aumentare di 1
    URL: string;
    ParamURLLista?: { [Param: string]: any };
    ParamURLClasse?: any
    ParamCorpo?: any
    Metodo?: Metodi;
    OnRis?: (sender: ChiamaAPI, dati: any, datiNuovi: boolean) => React.ReactNode;
    OnErrore?: (sender: ChiamaAPI, errore: Error) => React.ReactNode;
    OnInvio?: (sender: ChiamaAPI) => any;
    ImmaginePrecaricamento?: boolean | string;
}

export class ChiamaAPI extends React.Component<IChiamaAPIProps, {}> {
    private Attesa: string;
    private Contenuto: React.ReactNode;
    private Dati: any;
    private AncoraMontato: boolean = false;

    public static defaultProps: Partial<IChiamaAPIProps> = {
        Aggiornare: 0,
        Metodo: "GET",
        Nome: ""
    };

    constructor(props: any) {
        super(props);
        this.Attesa = "";
        this.ImmaginePrecaricamento();
        this.Dati = null;
    }

    private ImmaginePrecaricamento(): void {
        if (this.props.ImmaginePrecaricamento == undefined
            || (typeof (this.props.ImmaginePrecaricamento) == "boolean" && !this.props.ImmaginePrecaricamento)
            || (typeof (this.props.ImmaginePrecaricamento) == "string" && this.props.ImmaginePrecaricamento.toUpperCase() == "FALSE"))
            this.Contenuto = false;
        else if (this.props.ImmaginePrecaricamento == true
            || (typeof (this.props.ImmaginePrecaricamento) == "boolean" && this.props.ImmaginePrecaricamento)
            || (typeof (this.props.ImmaginePrecaricamento) == "string" && this.props.ImmaginePrecaricamento.toUpperCase() == "TRUE"))
            this.Contenuto = <div className={Glob.DimensioneCSS(12)} style={{ textAlign: "center" }}><img src="/images/loadingBig.gif" /></div>;
        else
            this.Contenuto = <div className={Glob.DimensioneCSS(12)} style={{ textAlign: "center" }}><img src={this.props.ImmaginePrecaricamento} /></div>;
    }

    private GestioneRedirect(url: string) {
        //console.warn("GestioneRedirect", url);

        if (Compat.ES6_String_endsWith(url, "/api/Utenti/SessioneScaduta")) {
            location.replace("/ErroreAccesso");
        }
        else {
            location.replace(url);
        }
    }

    public componentDidMount() {
        this.AncoraMontato = true;
        if (this.props.URL.length > 0 && (this.props.Aggiornare || 0) >= 0) {
            this.ChiamaAPI(this.props);
        }
    }

    public componentWillUnmount() {
        this.AncoraMontato = false;
    }

    public shouldComponentUpdate(nextProps: IChiamaAPIProps, nextState: any): boolean {
        let ProssimoAggiornare: number = nextProps.Aggiornare == undefined ? 0 : nextProps.Aggiornare;
        let CorrenteAggiornare: number = this.props.Aggiornare == undefined ? 0 : this.props.Aggiornare;
        let ProssimoURL: string = nextProps.URL == undefined ? "" : nextProps.URL;
        let CorrenteURL: string = this.props.URL == undefined ? "" : this.props.URL;
        if (ProssimoAggiornare != CorrenteAggiornare || ProssimoURL != CorrenteURL) {
            this.ChiamaAPI(nextProps);
        }
        else {
            if (this.Dati && nextProps.OnRis != undefined) {
                if (this.AncoraMontato) {
                    Glob.LogInfo(Glob.LogCat.API, false, "OnRis senza richiamare l'URL (" + nextProps.Nome + "): " + nextProps.URL);
                    this.Contenuto = nextProps.OnRis(this, this.Dati, false);
                }
                else {
                    Glob.LogInfo(Glob.LogCat.API, true, "Evitato OnRis perchè il componente non è più montato (" + nextProps.Nome + "): " + nextProps.URL);
                }
            }
        }
        return true
    }

    private CalcolaURL(props: IChiamaAPIProps): string {
        let URL: string = props.URL;
        if (props.ParamURLLista != undefined) {
            URL += (URL.indexOf("?") > -1 ? "&" : "?");
            for (let P in props.ParamURLLista) {
                URL += encodeURIComponent(P) + "=" + encodeURIComponent(props.ParamURLLista[P]) + "&";
            }
        }
        if (props.ParamURLClasse != undefined) {
            URL += (URL.indexOf("?") > -1 ? "&" : "?");
            for (let P in props.ParamURLClasse) {
                URL += encodeURIComponent(P) + "=" + encodeURIComponent(props.ParamURLClasse[P]) + "&";
            }
        }
        if (URL.toLowerCase().indexOf("sessione=") == -1) {
            URL += (URL.indexOf("?") > -1 ? "&" : "?") + "sessione=" + (Glob.GetSessione() && Glob.GetSessione().Sessione);
        }
        return URL;
    }

    private ChiamaAPI(props: IChiamaAPIProps) {
        let URL = this.CalcolaURL(props);
        if (this.Attesa == URL) {
            Glob.LogInfo(Glob.LogCat.API, "Già in attesa per caricamento ChiamaAPI (" + props.Nome + "): " + props.URL, [URL, this.Attesa]);
        }
        else {
            this.Attesa = URL;

            var RI: RequestInit = {};
            RI.headers = {
                'Accept': 'application/json', 'Content-Type': 'application/json'
            };
            if ((props.ParamCorpo != undefined || props.OnInvio != undefined) && props.Metodo == "GET") {
                RI.method = "POST";
            }
            else {
                RI.method = props.Metodo;
            }
            let TestoLog = "";
            if (props.ParamCorpo != undefined) {
                RI.body = JSON.stringify(props.ParamCorpo);
                TestoLog = "ParamCorpo";
            } else {
                if (props.OnInvio != undefined) {
                    let OnInvio = props.OnInvio(this);
                    if (OnInvio == false) {
                        this.Attesa = "";
                        return;
                    }
                    RI.body = JSON.stringify(OnInvio);
                    TestoLog = "OnInvio";
                }
                else {
                    TestoLog = "Vuoto";
                }
            }
            Glob.LogInfo(Glob.LogCat.API, "Attesa caricamento ChiamaAPI - " + TestoLog + "(" + props.Nome + "): " + RI.method + " " + props.URL, RI.body);

            fetch(URL, RI)
                .then(response => {
                    if (response.ok) {
                        response.text().then(text => {
                            let data = JSON.parse(text, Glob.DateReviver);

                            this.Attesa = "";
                            Glob.Log(Glob.LogCat.API, false, "Risultato caricamento ChiamaAPI (" + props.Nome + "): " + props.URL, data);
                            this.Dati = data;
                            if (props.OnRis != undefined) {
                                if (this.AncoraMontato) {
                                    if (response.redirected) {
                                        Glob.Log(Glob.LogCat.API, true, "Richiesto redirect (" + props.Nome + "): " + response.url);
                                        this.GestioneRedirect(response.url);
                                    }
                                    else {
                                        this.Contenuto = props.OnRis(this, this.Dati, true);
                                        if (this.Contenuto != undefined) {
                                            this.forceUpdate();
                                        }
                                    }
                                }
                                else {
                                    Glob.LogInfo(Glob.LogCat.API, "Evitato OnRis perchè il componente non è più montato (" + props.Nome + "): " + props.URL, data);
                                }
                            }
                        }).catch(e => {
                            this.Attesa = "";
                            Glob.Log(Glob.LogCat.API, true, "Errore caricamento ChiamaAPI (" + props.Nome + "): " + props.URL + " (JSON)", e);
                            if (props.OnErrore != undefined) {
                                if (this.AncoraMontato) {
                                    if (response.redirected) {
                                        Glob.Log(Glob.LogCat.API, true, "Richiesto redirect (" + props.Nome + "): " + response.url, e);
                                        this.GestioneRedirect(response.url);
                                    }
                                    else {
                                        this.Contenuto = props.OnErrore(this, e);
                                        if (this.Contenuto != undefined) {
                                            this.forceUpdate();
                                        }
                                    }
                                }
                                else {
                                    Glob.LogInfo(Glob.LogCat.API, "Evitato OnErrore perchè il componente non è più montato (" + props.Nome + "): " + props.URL + " (JSON)", e);
                                }
                            }
                        });
                    }
                    else {
                        this.Attesa = "";
                        Glob.Log(Glob.LogCat.API, true, "Errore caricamento ChiamaAPI (" + props.Nome + "): " + props.URL + " (HTTP)", response);
                        if (props.OnErrore != undefined) {
                            if (this.AncoraMontato) {
                                if (response.redirected) {
                                    Glob.Log(Glob.LogCat.API, true, "Richiesto redirect (" + props.Nome + "): " + response.url);
                                    this.GestioneRedirect(response.url);
                                }
                                else {
                                    this.Contenuto = props.OnErrore(this, new Error(response.statusText));
                                    if (this.Contenuto != undefined) {
                                        this.forceUpdate();
                                    }
                                }
                            }
                            else {
                                Glob.LogInfo(Glob.LogCat.API, "Evitato OnErrore perchè il componente non è più montato (" + props.Nome + "): " + props.URL + " (HTTP)", response);
                            }
                        }
                    }
                })
                .catch(e => {
                    this.Attesa = "";
                    Glob.Log(Glob.LogCat.API, true, "Errore caricamento ChiamaAPI (" + props.Nome + "): " + props.URL + " (Rete)", e);
                    if (props.OnErrore != undefined) {
                        if (this.AncoraMontato) {
                            if (e.toString() == "TypeError: Failed to fetch" || e.toString() == "TypeError: NetworkError when attempting to fetch resource.") {
                                Glob.LogInfo(Glob.LogCat.API, "Evitato OnErrore perchè l'errore è di tipo TypeError", e);
                            }
                            else {
                                this.Contenuto = props.OnErrore(this, e);
                                if (this.Contenuto != undefined) {
                                    this.forceUpdate();
                                }
                            }
                        }
                        else {
                            Glob.LogInfo(Glob.LogCat.API, "Evitato OnErrore perchè il componente non è più montato (" + props.Nome + "): " + props.URL + " (Rete)", e);
                        }
                    }
                });
        }
    }

    public render() {
        return this.Contenuto;
    }
}



// WEBPACK FOOTER //
// ./src/components/ChiamaAPI.tsx